const messages = {
  en: {
    translations: {
      documentTitle: {
        main: 'BaZi by Marina',
        home: '4 Pillars of Destiny (BaZi), I Ching and Feng Shui',
        about: 'About',
        services: {
          main: 'Services',
          bazi: 'BaZi',
          iChing: 'I Ching',
          fengShui: 'Feng Shui',
          nineStar: 'Nine Star Ki',
          dateSelection: 'Date Selection',
        },
        contact: 'Contact',
        articles: 'Articles',
        zodiacAnimals: 'Zodiac Animals',
        privacyPolicy: 'Privacy Policy',
        errorPage: 'Page not found',
      },
      header: {
        home: 'Home',
        about: 'About',
        services: {
          label: 'Services',
          bazi: 'BaZi or 4 Pillars of Destiny',
          iChing: 'I Ching',
          fengShui: 'Feng Shui',
          nineStar: 'Nine Star Ki',
          dateSelection: 'Date Selection',
        },
        press: null,
        faq: null,
        contact: 'Contact',
        articles: 'Articles',
      },
      homePage: {
        banner: {
          title: 'Uncover the patterns behind your date of birth',
          ctaButton: 'See more',
        },
        about: {
          title: 'What is BaZi',
          description:
            '<strong>BaZi or 4 Pillars of Destiny</strong>, is a tool for self-development. Because when revel our pattern of behavior in the world, we can understand ourselves better and others.',
          ctaButton: 'Know more',
        },
        horoscope: {
          title: 'Get to know your Chinese Zodiac sign characteristics',
          ctaButton: 'Discover now',
        },
        testimonials: {
          title: 'Testimonials',
          content: [
            {
              description:
                '“Thank you very much Marina for the quick return of my BaZi reading. It is highly accurate, very informative and guiding. I love it!!! I’m glad I chose you as my reader.”',
              author: '<strong>Lilian Paiva - Bruxelas</strong>',
            },
            {
              description:
                '“We have had the privilege to meet Marina in Hong Kong. Our admiration for her deep dedication to learn all she could in terms of Feng Shui, Chinese culture and astrology. it was a very pleasant surprise on her deep interpretation, calculation and suggestions on what to do and carefully spoken steps that I should be taken to bring a positive outcome of the causes-and-effects that govern our daily lives. I could not describe how great this experience has been and I am looking forward to continuing learning with the thousands-year-old Chinese wisdom that Marina brings with her!”',
              author: '<strong>Luis Alexandre Gomes - Hong Kong</strong>',
            },
            {
              description:
                '“Knowing Marina Caramez for more than 20 years I could personally see how passionate she became about the Chinese culture after living in Hong Kong for 4 years. Marina became a rare expert outside of China about Bazi, 4 Pillars, Ching and Feng Shui being trained by Chinese grand masters. Of course, Marina did my 4 pillars, and it was amazing to notice that she could see important details about my life and business that later in the future turned into reality” Love you!!!! 😍',
              author: '<strong>Christiano Marchesini – Miami</strong>',
            },
            {
              description:
                '“Marina provided a reading that was both thorough and accurate which completely took me by pleasant surprise. Not only did the reading provide informative and helpful responses to the answers I wished to seek, but it was the details of the reading itself that really impressed me. I would have no hesitation to seek advice from Marina in the future again.”',
              author: '<strong>Amil Khan - Hong Kong</strong>',
            },
          ],
        },
        whoIsMarina: {
          title: 'Marina Caramez',
          description:
            'My name is Marina Caramez and I am a <strong>Consultant of Chinese Metaphysics</strong>. Chinese metaphysics encompasses important sciences such as the 4 Pillars of Destiny, I Ching and Feng Shui. I hold three certifications from Raymond Lo’s School of Feng Shui and Destiny in Hong Kong and San Francisco.<br /><br />Using this ancient knowledge my goal is <strong>to help clients in making informed decisions</strong> in all aspects of their lifes whether it is business, career, job, relationship or health to bridge a gap between their expectations and achievements.',
          ctaButton: 'Know more',
        },
        recentArticles: {
          title: 'Check out our latest articles',
          link: 'See the full article ',
        },
        faq: {
          title: 'Frequently Asked Questions',
          questions: [
            {
              title: '<strong>How does the Chinese calendar work?</strong>',
              answer:
                'The Chinese calendar is lunisolar, in other words, it’s based on Moon cycles and Sun cycles, while the Western calendar is based on the Sun only. For major celebrations, such as Chinese New Year, the lunar calendar is used, so this date can change and usually falls between the end of January and the beginning of February. However, the animal sign that rules the year always begins at the beginning of the spring season, usually on February 4th of each year.',
            },
            {
              title: '<strong>What is Feng Shui?</strong>',
              answer:
                'Feng Shui is an ancient Chinese science that studies the effects of natural and built environment energies on people, their health, their relationships and their prosperity. The main goal of Feng Shui is to harmonize these energies, making spaces more welcoming when staying in the office or at home, or in environments such as bedrooms, living rooms, kitchens and others. There is no space where Feng Shui cannot be applied on.',
            },
            {
              title:
                '<strong>How BaZi astrology works - as known as 4 Pillars of Destiny - can it help me?</strong>',
              answer:
                'BaZi Astrology is a very effective and accurate tool for self-knowledge and destination analysis as well. This tool was designed so that we can anticipate situations that challenge us, in order to mitigate them. How? Adjusting our activities in these periods and finding the best moments to make important decisions.',
            },
            {
              title: '<strong>What is Nine Star Ki?</strong>',
              answer:
                'Nine Stars Ki is an astrology system based on the ancient knowledge of the Chinese and Japanese civilizations that helps us to understand our psychological profile, in other words, who we really are in our essence. In this way we learn how to act in a more careful and insightful way to avoid unnecessary problems in the future. The most important thing is to know yourself. When you start to realize who you truly are, you begin to better understand other people, the events that happened to you, your choices and much more.',
            },
            {
              title: '<strong>What is the I Ching used for?</strong>',
              answer:
                'The I Ching is basically a tool for asking questions and getting answers that has been used for over 5,000 years by Chinese civilization. The I Ching reveals information about the present moment and future trends, revealing patterns existing at a given time. With this knowledge in hand, you have the free will to decide whether to follow these standards, or if you act, in order to influence the situation in a direction that is more favorable to you.',
            },
          ],
        },
        instagram: {
          title: 'Follow us on Instagram',
        },
      },
      articles: {
        title: 'Articles',
        predictions: 'Predictions',
        disclaimer:
          'Keep in mind that for a more accurate reading your BaZi chart must be analyzed.',
        yearOfBirth: 'Year of Birth: ',
        backToArticle: 'Back to article',
        articleUnavailable: 'Item currently unavailable',
        recentArticlesColumn: {
          title: 'Recent Articles',
          link: 'See article',
        },
        contentFields: {
          career: 'career',
          conclusion: 'conclusion',
          love: 'love',
          health: 'health',
        },
      },
      faq: {
        title: 'Frequently Asked Questions',
        questions: [
          {
            title:
              '<strong>Utilized as an oracle for over three thousand years, what sets the I Ching apart from other methods of divination and self-knowledge?</strong>',
            answer: '/videos/pergunta-1.mp4',
          },
          {
            title:
              '<strong>How would you define BaZi or the Four Pillars of Destiny to someone who has never come across this term and method before?</strong>',
            answer: '/videos/pergunta-2.mp4',
          },
          {
            title:
              '<strong>In your perspective and professional experience, what is the difference between Western and Chinese astrology?</strong>',
            answer: '/videos/pergunta-3.mp4',
          },
          {
            title:
              '<strong>Some people often relate the animals of the Chinese zodiac to those associated with Western signs, such as Capricorn and the Goat or the Ox and the Bull. Is there any correlation between them?</strong>',
            answer: '/videos/pergunta-4.mp4',
          },
          {
            title:
              '<strong>Regarding the influences between methods and tools, what would be the definition of the Nine Stars Ki?</strong>',
            answer: '/videos/pergunta-5.mp4',
          },
          {
            title:
              "<strong>Again, concerning the Nine Stars Ki, does it have any compatibility with the Western astrological system? After all, we can observe that it also addresses different energetic manifestations according to our age, childlike and adult nature. Similarly to the relationship between the Sun sign and the ascendant after Saturn's return around the age of 30?</strong>",
            answer: '/videos/pergunta-6.mp4',
          },
          {
            title:
              '<strong>Taking into consideration that the Nine Stars Ki attributes 3 stars to us at birth, there is a statement that some people can go through their entire lives without coming into contact with their true nature, keeping it almost inaccessible and only living in contact with their second and third numbers. How can we stimulate ourselves to come into contact with our first number, that is, our essence?</strong>',
            answer: '/videos/pergunta-7.mp4',
          },
          {
            title:
              '<strong>In many Eastern therapies, the importance of proper manipulation of Ki is discussed. Is it possible to strengthen this energy or influence it in any way?</strong>',
            answer: '/videos/pergunta-8.mp4',
          },
          {
            title:
              '<strong>Speaking of Feng Shui, we know that there are various schools, some of which have divergent opinions on certain subjects. How can we determine the best approach for our needs? And what are the main differences between these schools?</strong>',
            answer: '/videos/pergunta-9.mp4',
          },
          {
            title:
              '<strong>Does living in the Southern Hemisphere affect how Feng Shui should be applied?</strong>',
            answer: '/videos/pergunta-10.mp4',
          },
          {
            title:
              '<strong>And finally, for those who have never had any contact with any of the methods presented here, what is the starting point for someone to truly begin the process of self-knowledge and make definitive changes in their life? Assuming the individual has a specific issue in their personal, professional, or health life and wants to work on it.</strong>',
            answer: '/videos/pergunta-11.mp4',
          },
        ],
      },
      zodiacAnimals: {
        title: 'The animals of the Zodiac',
        content:
          "Do you know your chinese zodiac sign? Below you can see the 12 animals or signs and their respective years of birth. It is worth noting that <strong>if you were born up to February 3rd, your sign belongs to the previous year's animal.",
        horoscope: {
          title: 'Check out the 2024 predictions for each sign',
          description:
            'Find out what opportunities and challenges this year has in store for you!',
          mediaPath: '/images/zodiacAnimals/clouds-mobile.webp',
          ctaButton: 'Know more',
          ctaLink: '/articles/chinese-new-year-2024',
        },
      },
      footer: {
        institutional: {
          label: 'Institutional',
          home: 'Home',
          about: 'About',
          press: null,
          faq: null,
          contact: 'Contact',
          zodiac: 'The animals of the Zodiac',
          articles: 'Articles',
          privacyPolicy: 'Privacy policy',
        },
        services: {
          label: 'Services',
          bazi: 'BaZi or 4 Pillars of Destiny',
          iching: 'I Ching',
          fengshui: 'Feng Shui',
          ki: 'Nine Star Ki',
          dateselection: 'Date Selection',
        },
        contact: {
          label: 'Contact',
        },
        copyright:
          '© {{currentYear}}. BaZi by Marina. All rights reserved. Developed by',
      },
      aboutPage: {
        title: 'About',
        marina: {
          description:
            "Chinese Metaphysics Consultant, Marina Caramez is a graduate of Raymond Lo's School of Feng Shui and Destiny in Hong Kong and San Francisco, where she was a student of Grand Master Raymond Lo, one of the 5 most important masters in Asia.<br /><br />Although she started her career in law, she discovered her passion for photography a few years later. Interestingly, it was through this hobby that she found her way. In 2012, she moved to Hong Kong, where she lived for 4 years, and came to know Chinese Metaphysics.<br /><br /><strong><i>”Photographing the Urban Scenery of Hong Kong, Shanghai, Beijing and other major urban centers in Asia, I was able to observe certain peculiarities in architecture, both classical and modern, and all of them were related to Feng Shui.”</i></strong><br /><br />Marina continues to study and developing her techniques within Chinese metaphysics.",
        },
        mission: {
          title:
            'Marina graduated in China, with one of the 5 most important masters in Asia',
          description:
            'Using all this millenary knowledge acquired by Marina, the brand BaZi by Marina was born, which, through Chinese Metaphysics, aims to <strong>help customers make better decisions in various aspects of their lives, be it business, career, work , relationships, or even health, in order to bridge the gap between your expectations and achievements.</strong><br /><br />This knowledge will also guide you in finding your own answers, which is undoubtedly what starting point for any personal development.',
        },
      },
      services: {
        defaultTitle: 'Services',
        alternativeTitle: 'View other services',
        content: [
          {
            title: 'BaZi or 4 Pillars of Destiny',
            description:
              'It contains all the in-depth information about who you are, what your destiny holds (positive and negative things) and how to manage it.',
            icon: '/icons/kanji-bazi-red.svg',
          },
          {
            title: 'I Ching',
            description:
              "<strong>I Ching</strong> is a tool used to predict the events which will govern and shape our destiny, providing advice and guidance to life's questions.",
            icon: '/icons/kanji-iching-red.svg',
          },
          {
            title: 'Feng Shui',
            description:
              '<strong>Feng shui</strong> is essentially the interaction of humans and their environments. The intent is to bring harmony to the home and the environment and, in doing so, to the person as well.',
            icon: '/icons/kanji-fengshui-red.svg',
          },
          {
            title: 'Nine Star Ki',
            description:
              '<strong>Nine Star Ki</strong> is a tool to becoming aware of our spiritual essence and understanding our patterns of behaviour. Most importantly, it shows you how amazing it is to just be you!',
            icon: '/icons/kanji-ninestar-desktop-red.svg',
          },
          {
            title: 'Date Selection',
            description:
              '<strong>Date Selection</strong> helps you identify the most favourable moment for plan, execute or join a journey towards what you most desire.',
            icon: '/icons/kanji-date-red.svg',
          },
        ],
        ctaButton: 'Know more',
        timeline: [
          {
            year: '2013',
            content:
              '<strong>Graduated from Feng Shui and Chinese Metaphysics in Hong Kong with Grand Masters Raymond Lo, one of the 5 most important masters in Asia</strong>',
          },
          {
            year: '2018',
            content:
              '<strong>Graduated from Advanced Chinese Metaphysics in San Francisco</strong>',
          },
          {
            year: '2019',
            content: '<strong>Brand creation BaZi by Marina</strong>',
          },
          {
            year: '2020',
            content:
              '<strong>BaZi Specialization with Grandmaster Lily Chung</strong>',
          },
          {
            year: '2021',
            content:
              '<strong>Graduated from Nine Star Ki by the Feng Shui Academy in Lisbon</strong>',
          },
          {
            year: '2022',
            content:
              '<strong>Specialization in Date Selection with Richard Ashworth, one of the most respected Masters of Chinese Metaphysics in the West</strong>',
          },
        ],
      },
      servicePages: {
        iChing: {
          title: 'I Ching',
          understandingIChing: {
            title: 'Understanding the I Ching',
            kanjiPath: '/icons/kanji-iching-red.svg',
            description:
              'The I Ching is basically a tool for asking questions and getting answers used for over 5000 years by the Chinese civilization.<br /><br /><strong>I Ching provides us present information about our future potentials.</strong><br /><br />This ancient knowledge is capable of revealing existing patterns in a determined moment.<br /><br /><strong>By clarifying these patterns (your present situation and future potential or tendency), it leaves your free will to decide whether to follow them as they are or let it influence your response to situation.</strong>',
            mediaPath: '/images/iChing/marina-holding-iching-card.webp',
          },
          howItHelps: {
            title: 'I Ching supports your decision making',
            description:
              '<strong>The beauty of I Ching is that it helps us to act.</strong> It starts a process which after we determine the best actions to take in the situation we are facing.<br /><br />I am often asked when to consult the I Ching. I say that when we hesitate about a path to follow, a choice to make or we have a dilemma to solve then we can use it for what it really is: a tool to help making decisions. Since we are living in a world of profound changes it is a privilege to access such informations for better decisions.',
            mediaPath: 'https://www.youtube.com/embed/vijlKd3aoaY',
            ctaButton: 'Get in touch',
          },
          formTitle: 'Get the guidance you need',
        },
        BaZi: {
          title: 'BaZi or 4 Pillars of Destiny',
          destinyCode: {
            title: 'Destiny Code',
            kanjiPath: '/icons/kanji-bazi-red.svg',
            description:
              "The term BaZi 八字  or 4 Pillars of Destiny is derived from the presentation format of an individual's personal energy chart, which takes the form of 4 Pillars and 8 Chinese Characters.<br /><br />In Chinese Astrology, <strong>the day and time of your birth are seen as an energy blueprint</strong> that tells a specific story. This date and time of birth is represented by what's known as a <strong>“Four Pillars Chart“</strong>.<br /><br />The Four Pillars are the <strong>Year, the Month, the Day and the hour of your Birth</strong> and each one represents one’s lessons, gifts, talents, and challenges.",
            appendix:
              'This chart outlines events and life-path that are in store for you in the future. The events are predetermined to some extent but can be modified by the effects of your decisions.<br /><br />By understanding yourself and the energy and lessons that you were born with, you can consciously choose differently. With awareness, it is possible to change all aspects of yourself and in the process change the outcome and personally grow.<br /><br />In short, Destiny Analysis allow us to investigate the mystery behind your life purpose, your inert talent, personality, strengths & weaknesses. <strong>The the basic premise of the BaZi is to help you understand your unique cosmic blueprint</strong>, so you can arm yourself with the knowledge and power to steer your fate in any direction you desire!',
          },
          zodiacCarousel: {
            title: 'The animals of the Zodiac',
          },
          baziPrecision: {
            title: 'How accurate is BaZi Analysis?',
            description:
              "The possibility of two people having identical BaZi charts are 1 in 12.96 million. It also takes 240 years for the next cycle to produce another case of identical BaZi. With such differentiation, a high level of detailed calculations is required in order to have accuracy while trying to unravel one's destiny<br /><br />When a person is born, they capture the energy or the elements of that exact moment, and the composition of these elements is your fingerprint in the world. BaZi is like your spiritual fingerprint that explains the WHY of your life, and give you clues about the HOW to transform it.<br /><br />Understanding your inner self will help you create a successful, happy life. Knowing your strengths and weaknesses will give you powerful insights into the best timing, the best opportunities, and the best relationships in your life. This is the basic premise of the Bazi.",
            mediaPath: 'https://www.youtube.com/embed/5tOVpv3KTOw',
            ctaButton: 'Get in touch',
          },
          formTitle: 'Know what fate has in store for you',
        },
        nineStar: {
          title: 'Nine Star Ki',
          kanjiPath: '/icons/kanji-ninestar-mobile-red.svg',
          thePowerOfNineStar: {
            title: 'The power of Nine Star Ki',
            description:
              'Nine Star Ki is possibly the oldest system of astrology in the world today, based on the ancient knowledge of the Chinese and Japanese civilisations.<br /><br />Ki (Japanese Term), aka Chi or Qi (Chinese Terms) <strong>refers to Life Force or Universal energy.</strong><br /><br />The system is closely related to the 4000-year-old Chinese Book of Changes (the I Ching), whose principles are the foundations of Feng Shui, traditional Chinese medicine, the concepts of yin and yang and the Five Elements theory.',
            mediaPath: '/images/nineStar/calendar.webp',
            appendix:
              "In Nine Star Ki, you're assigned three stars when you're born. <strong>These star energies provide you with various characteristics and traits and they form your Nine Star Ki Energetic Signature:</strong>",
          },
          signatureTabs: [
            [
              'Personality',
              'It provides you with information on who you innately are. That is, <strong>who you came here to be</strong>. It is the essence of who you are. It denotes your true inner (adult) nature. This nature does not surface until you have been through two cycles of 9 years - when one turns 18 and emerges as an independent person. Some people can go through their whole life and not tap into their true nature, keeping it deep inside and living only by their second or third numbers.',
            ],
            [
              'Childhood',
              '<strong>It tells you about your emotional nature, childhood, and the way you communicate</strong> (hence the most important in close relationships) and your dependent nature. Most adults live by their First Adult Nature and with their second emotional nature surfacing when they are emotional (happy, exhilarated etc) or under stress.',
            ],
            [
              'Actions',
              'Lastly, it provides you with information on how others see you upon first impression. <strong>It is your outer personality.</strong> As well, <strong>it reveals your greatest strength and your greatest challenge in life.</strong> Sometimes it is not a true reflection of who you are, but it is the nature people first see in you. Many personal relationships fail because the initial attraction is based on this nature and not on the first number, the true inner nature. ',
            ],
          ],
          whyNineStarPartOne: {
            title: 'Why consulting Nine Star Ki?',
            description:
              'Nine Star Ki is invaluable in helping us to get in touch with our basic, conditioned nature with all its strengths and weaknesses.<br /><br /><strong>People are turning to Nine Star Ki to understand their true potential, natural skills, and leadership abilities</strong> – asking the questions what makes me tick? What was I born to do?',
            mediaPath: '/images/nineStar/singularity.webp',
          },
          whyNineStarPartTwo: {
            description:
              'Nine Star Ki will also help you to understand more about your personal health and your response to stress and change – why performing certain tasks comes more naturally than others and how to get back on track if out of balance.<br /><br /><strong>In short, Nine Star Ki is a tool to becoming aware of our energetic tendencies, understanding our patterns of behaviour, and managing our future and destiny.</strong>',
            mediaPath: '/images/nineStar/certificate.webp',
            ctaButton: 'Write a review',
          },
          formTitle: 'Understand your true essence',
          badgeList: {
            title: 'Nine Star Ki Energy Signature',
            badges: [
              ['Personality', '/images/badges/nineStar/personalidade.webp'],
              ['Childhood', '/images/badges/nineStar/infancia.webp'],
              ['Actions', '/images/badges/nineStar/acoes.webp'],
            ],
          },
        },
        fengShui: {
          title: 'Feng Shui',
          understandingFengShui: {
            title: 'Understanding Feng Shui',
            kanjiPath: '/icons/kanji-fengshui-red.svg',
            description:
              'Feng Shui initially began as a set of principles that were used to determine the most ideal locations for a village to be situated <strong>in relation to its natural surroundings.</strong> This relationship was found to be the single determining factor as to whether a community thrived (by living in harmony with their natural surroundings) versus just barely survived (by working against the forces of nature, and not living in harmony with their natural surroundings).<br /><br />Therefore, <strong>Feng Shui is the study of how the energy or Qi in our working and living environments affect us.</strong> Feng Shui techniques allow us to mitigate the negative influences while enhancing the positive ones.',
            mediaPath: 'https://www.youtube.com/embed/qxRM7NVSaJY',
            appendix:
              '“Feng” means wind and “Shui” means water. <strong>Feng - the wind, refers to the invisible or intangible qi that flows through a space. Shui - the water, is the visible, more tangible flow of qi.</strong><br /><br />Feng Shui is essentially the study of the interaction of humans and their environment. It enables you to influence these interacting energies to achieve specific life improvements.<br /><br />Feng Shui can be applied to all spaces where people live, work, recreate and interact.',
          },
          whatIsKi: {
            title: 'What is Qi?',
            description:
              'Qi is energy in the very broadest sense possible. <strong>Qi embraces all manifestations of energy, from the most material aspects of energy</strong> (such as the earth beneath your feet, your computer, and flesh and blood) <strong>to the most immaterial aspects</strong> (light, movement, heat, nerve impulses, thought, and emotion).<br /><br /><strong>Life is a gathering of Qi.</strong> A healthy (and happy) human being is a dynamic but harmonious mixture of all the aspects of Qi that make up who we are.<br /><br />Qi is in a state of continuous flux, transforming endlessly from one aspect of Qi into another. It is neither created nor is it ever destroyed; it simply changes in its manifestation.',
            mediaPath: '/images/fengShui/blueprint.webp',
          },
          whatToExpect: {
            title: 'What to expect from a Feng Shui consultant',
            description:
              "The job of a Feng Shui consultant is to identify positive and negative factors in the environment and to suggest strategies and remedies toward the balancing of both.<br /><br />With every home or office's Feng Shui audit I will make recommendations for enhancements of the positives and balancing of the negatives - but the choice is always yours to implement.",
            mediaPath: '/images/fengShui/marina-consultant.webp',
            ctaButton: 'Write a review',
          },
          formTitle: 'Create a healthy home',
          badgeList: {
            title: 'I will take into account:',
            badges: [
              ['The environment', '/images/badges/fengShui/ambiente.webp'],
              [
                'The form and direction of the property',
                '/images/badges/fengShui/forma.webp',
              ],
              ['The time factor', '/images/badges/fengShui/tempo.webp'],
              ['The residents', '/images/badges/fengShui/residentes.webp'],
            ],
          },
          bonusServices: {
            title: 'At the end, you will receive:',
            bonusList: [
              [
                '/icons/ellipse.svg',
                'Detailed report to be provided electronically with reference materials, observations and recommendations.',
              ],
              [
                '/icons/ellipse.svg',
                'Floor plan analysis with auspicious sectors related to career, money, relationships, health and wealth.',
              ],
              [
                '/icons/ellipse.svg',
                'A basic BaZi chart analysis for 1-2 residents (1-hour online session)',
              ],
            ],
          },
        },
        dateSelection: {
          title: 'Date Selection',
          auspiciousSelection: {
            title: 'Auspicious date selection',
            kanjiPath: '/icons/kanji-date-red.svg',
            description:
              'The concept of <strong>Date Selection</strong> refers to carrying out an activity in the period when the energies of the Universe are favorable for a particular endeavor.<br /><br />The Chinese believed that there is a perfect time to perform a specific activity where the energy of heaven and earth are in harmony.<br /><br /><strong>Through observing the laws of nature and astronomy</strong>, the peoples of ancient China created a system in which they were able to identify certain days of the year when events could occur without problems, and used them to successfully carry out certain activities.<br /><br /><strong>Choosing the perfect day for important occasions makes all the difference.</strong> Life milestones create memories. These memories we carry throughout our existence, and when positive, they have the power to boost us even further.',
            mediaPath: '/images/dateSelection/marina.webp',
          },
          aPowerfulTool: {
            title: 'A powerful tool',
            description:
              '<strong>Date selection puts you on the right day to carry out certain activities more easily and with less unforeseen circumstances.</strong><br /><br />The study of date selection is personalized, as we will analyze the energy quality of your natal chart in comparison to the energy quality of certain days, <strong>seeking to align both in the most beneficial and productive way for you.</strong><br /><br />Who has never carefully prepared for an event and yet everything goes wrong? Certainly the energy of this day was not in harmony with your personal energy!',
            mediaPath: '/images/dateSelection/books.webp',
          },
          formTitle: 'Make decisions at the best time of your life',
          badgeList: {
            title:
              'Take advantage of the opportunity to use the energy of each day in your favor',
            subtitle:
              'Learn about some situations where <strong>Date Selection</strong> is very beneficial:',
            badges: [
              ['Wedding', '/images/badges/dateSelection/casamento.webp'],
              [
                'Contract signing',
                '/images/badges/dateSelection/contrato.webp',
              ],
              ['Moving', '/images/badges/dateSelection/mudanca.webp'],
              ['Travel', '/images/badges/dateSelection/viagem.webp'],
              ['Company opening', '/images/badges/dateSelection/empresa.webp'],
              ['Surgery', '/images/badges/dateSelection/cirurgia.webp'],
              ['Job interview', '/images/badges/dateSelection/trabalho.webp'],
              ['Start renovation', '/images/badges/dateSelection/reforma.webp'],
            ],
          },
        },
        form: {
          namePlaceholder: 'Name',
          emailPlaceholder: 'E-mail',
          options: {
            bazi: 'BaZi or 4 Pillars of Destiny',
            iChing: 'I Ching',
            fengShui: 'Feng Shui',
            nineStar: 'Nine Star Ki',
            dateSelection: 'Date Selection',
          },
          messagePlaceholder: 'Message (optional)',
          submitButton: 'Send',
        },
      },
      error: {
        notFound: {
          title: 'Oops!',
          description: 'Sorry, something went wrong while loading the page.',
        },
        form: {
          email: {
            invalid: '* Invalid email',
            required: '* Email is required',
          },
          name: {
            required: '* Name is required',
          },
          message: {
            required: '* Message is required',
          },
        },
      },
      zodiacCards: {
        rat: {
          icon: '/icons/zodiac/rat.svg',
          title: 'Rat',
          years: [
            '1924',
            '1936',
            '1948',
            '1960',
            '1972',
            '1984',
            '1996',
            '2008',
            '2020',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'adaptable',
              'quick-witted',
              'optimistic',
              'considerate',
              'versatile',
              'outgoing',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'timid',
              'stubborn',
              'picky',
              'lack of persistence',
              'self-centred',
            ],
          },
        },
        ox: {
          icon: '/icons/zodiac/ox.svg',
          title: 'Ox',
          years: [
            '1925',
            '1937',
            '1949',
            '1961',
            '1973',
            '1985',
            '1997',
            '2009',
            '2021',
          ],
          strengths: {
            title: 'Strengths',
            list: ['loyal', 'honest', 'responsible', 'hard-working', 'logical'],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'less-talkative',
              'conservative',
              'stubborn',
              'overcautious',
            ],
          },
        },
        tiger: {
          icon: '/icons/zodiac/tiger.svg',
          title: 'Tiger',
          years: [
            '1926',
            '1938',
            '1950',
            '1962',
            '1974',
            '1986',
            '1998',
            '2010',
            '2022',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'brave',
              'passionate',
              'optimistic',
              'likes challenges and love adventures',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: ['rebellious', 'overconfident', 'stubborn', 'emotional'],
          },
        },
        rabbit: {
          icon: '/icons/zodiac/rabbit.svg',
          title: 'Rabbit',
          years: [
            '1927',
            '1939',
            '1951',
            '1963',
            '1975',
            '1987',
            '1999',
            '2011',
            '2023',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'optimistic',
              'gracious',
              'generous',
              'kind-hearted',
              'witty and alert',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'a little vain',
              'emotionally unstable',
              'easily satisfied with the status-quo',
            ],
          },
        },
        dragon: {
          icon: '/icons/zodiac/dragon.svg',
          title: 'Dragon',
          years: [
            '1928',
            '1940',
            '1952',
            '1964',
            '1976',
            '1988',
            '2000',
            '2012',
            '2024',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'Determined',
              'ambitious',
              'independent',
              'energetic',
              'sincere and enjoy great popularity among friends',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'Easily give up',
              'little willpower and unwilling to admit mistakes',
            ],
          },
        },
        serpent: {
          icon: '/icons/zodiac/serpent.svg',
          title: 'Serpent',
          years: [
            '1929',
            '1941',
            '1953',
            '1965',
            '1977',
            '1989',
            '2001',
            '2013',
            '2025',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'calm',
              'talented',
              'modest',
              'perceptive',
              'intelligent and have a lot of inspirations',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: ['indifferent', 'skeptical', 'possessive and obstinate'],
          },
        },
        horse: {
          icon: '/icons/zodiac/horse.svg',
          title: 'Horse',
          years: [
            '1930',
            '1942',
            '1954',
            '1966',
            '1978',
            '1990',
            '2002',
            '2014',
            '2026',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'inspired',
              'cheerful',
              'talented',
              'perceptive',
              'intelligent and popular in social circle',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'overly ambitious',
              'overconfident and sometimes too sophisticated',
            ],
          },
        },
        goat: {
          icon: '/icons/zodiac/goat.svg',
          title: 'Goat',
          years: [
            '1931',
            '1943',
            '1955',
            '1967',
            '1979',
            '1991',
            '2003',
            '2015',
            '2027',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'gentle',
              'sympathetic',
              'calm',
              'creative',
              'imaginative',
              'sociable and considerate',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'negative',
              'hesitating',
              'impractical and sometimes stubborn',
            ],
          },
        },
        monkey: {
          icon: '/icons/zodiac/monkey.svg',
          title: 'Monkey',
          years: [
            '1932',
            '1944',
            '1956',
            '1968',
            '1980',
            '1992',
            '2004',
            '2016',
            '2028',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'active',
              'quick-witted',
              'smart',
              'humorous',
              'sociable',
              'capable',
              'brave',
              'just',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'braggart',
              'tricky',
              'opportunistic',
              'impatient',
              'vainglorious',
            ],
          },
        },
        rooster: {
          icon: '/icons/zodiac/rooster.svg',
          title: 'Rooster',
          years: [
            '1933',
            '1945',
            '1957',
            '1969',
            '1981',
            '1993',
            '2005',
            '2017',
            '2029',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'independent',
              'capable',
              'warm-hearted',
              'self-respect',
              'quick minded',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'impatient',
              'critical',
              'eccentric',
              'narrow-minded',
              'selfish',
            ],
          },
        },
        dog: {
          icon: '/icons/zodiac/dog.svg',
          title: 'Dog',
          years: [
            '1934',
            '1946',
            '1958',
            '1970',
            '1982',
            '1994',
            '2006',
            '2018',
            '2030',
          ],
          strengths: {
            title: 'Strengths',
            list: ['brave', 'loyal', 'responsible', 'clever', 'lively'],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: ['sensitive', 'conservative', 'stubborn', 'emotional'],
          },
        },
        pig: {
          icon: '/icons/zodiac/pig.svg',
          title: 'Pig',
          years: [
            '1935',
            '1947',
            '1959',
            '1971',
            '1983',
            '1995',
            '2007',
            '2019',
            '2031',
          ],
          strengths: {
            title: 'Strengths',
            list: [
              'diligent',
              'sincere',
              'positive',
              'responsible',
              'compassionate',
              'generous',
            ],
          },
          weaknesses: {
            title: 'Weaknesses',
            list: [
              'easily influenced',
              'realistic',
              'emotional',
              'self-indulgent',
            ],
          },
        },
      },
      contact: {
        title: 'Contact',
        formAdvice: 'Do you have any questions? Send us your message!',
        form: {
          name: 'Name',
          email: 'Email',
          message: 'Message',
          ctaButton: 'Send',
          successMessage:
            'Your message has been sent. We will contact you soon!',
        },
      },
      breadcrumbRoot: 'Home',
      privacyPolicy: {
        title: 'Privacy Policy',
        label: 'privacy-policy',
        description:
          'Welcome to the <strong>BAZI BY MARINA</strong> website (<a href="https://www.bazibymarina.com" target="_blank">https://www.bazibymarina.com/</a>).\n\nPlease read this information carefully, it indicates how your data is collected, used and protected on the <strong>BAZI BY MARINA</strong> website. By providing Personal Information or browsing the site, you automatically agree with the rules of use, protection and security set forth herein.\n\nFor the purposes of this Privacy Policy, "Users" or "You" mean all individuals who in any way access the Site and/or use the services of <strong>BAZI BY MARINA</strong>. ',
        content: [
          {
            title: '1. GENERAL INFORMATION ',
            sectionContent:
              "<strong>BAZI BY MARINA</strong> values the privacy of its visitors and Users, therefore, this Privacy Policy describes how <strong>BAZI BY MARINA</strong> protects your privacy and your Personal Data, as well as collects, processes and stores your Personal Information, under the terms of General Data Protection Law (“Lei Geral de Proteção de Dados” ou “LGPD”) and other regulations related to the subject.\n\nThis Privacy Policy applies to all Users who access or use the Site and/or the Services of <strong>BAZI BY MARINA</strong> whether online or offline, including without limitation the use of our website <a href='https://www.bazibymarina.com' target='_blank'>https://www.bazibymarina.com/</a>.\n\nThis Privacy Policy is complementary to the Users' privacy guarantee, not intending to replace the terms and conditions of any contract or privacy clause that the User may have with <strong>BAZI BY MARINA</strong>, nor any other rights that they may have under the terms of regulations, contracts and/or specific documents.\n\nBy registering on our platform, you accept our Privacy Policy and indicate that you have full and express capacity, including the legal capacity, to accept the terms and conditions of this Policy for all legal purposes. If you do not agree, even in part, with our Policy and/or do not fit the description above, you must disconnect and stop using our Services.",
          },
          {
            title: '2. PERSONAL DATA AND INFORMATION COLLECTION ',
            sectionContent:
              '“Personal Data” is information about an identified or identifiable natural person. Examples of Personal Data are the name, profession, identification document, address, e-mail, telephone number, schooling, among others.\n\n“Processing” means any operation carried out with Personal Data, such as those referring to the collection, production, reception, classification, use, access, reproduction, transmission, distribution, processing, archiving, storage, elimination, evaluation or control of information, modification, communication, transfer, diffusion or extraction.\n\n“Holder” is the natural person to whom the Personal Data that are the subject of Processing refer. ',
          },
          {
            title: '2.1. USER INFORMATION ',
            sectionContent:
              "In the performance and progress of its Services, <strong>BAZI BY MARINA</strong> needs to collect some Personal Information from its Users, being certain, however, that the information collected is only that necessary to provide satisfactory Services. This collection is mainly intended to provide services to the User, but also to personalize and facilitate their future visits and to help <strong>BAZI BY MARINA</strong> to better direct its strategies and its personalized service.\n\nBAZI BY MARINA collects Personal Data when the User registers for an event, sends information to apply for a vacancy/job, when he fills out a “contact” form throw the Website, when he sends us documents and information in meetings (virtual or face-to-face) or through communications via WhatsApp, calls or emails.\n\nPersonal data may be collected directly from the Data Subject, may be obtained from someone related to the Data Subject (for example, the company that the User is part of) or may be accessed from publicly accessible sources. Regardless of the origin of the data, the treatment will be governed by this Privacy Policy and the User may contact us via e-mail <a href='mailto:marina.caramez1@gmail.com' target='_blank'>marina.caramez1@gmail.com</a> in case of doubts.\n\n Within the limits permitted by applicable law, <strong>BAZI BY MARINA</strong> may process the personal data described below.\n\na) Information you send us: When you register for our Services and/or when you contact us directly through any communication channel, you may send us Personal Information such as your name, email address, telephone number, home address/commercial information, payment Personal Information, other Personal Information that you may include in your communications with us and Personal Information contained in scanned identification documents (such as an identity card, driver's license, official company registration documents, among others);\n\nb) Information we collect when you use the Services: As most Internet services, when you visit our websites, download and/or use any of our Services, we collect certain information automatically. This information includes Visitors' and Users' browsing and streaming activity on the Services, heatmaps and session scrolls, Non-Identifying Personal Information relating to the Visitor's or User's device, operating system, internet browser, screen resolution, language and keyboard settings, ISP, forwarding/exit pages, date/time stamps, Internet Protocol (IP) addresses, websites and clickstream data, among others;\n\nc) Information We Collect From Other Sources: We may receive Personal Information about you from third party sources, such as i) security providers, fraud detection and prevention providers, for example, to help us screen Users associated with fraud; and ii) advertising and marketing partners to monitor, manage and measure our advertising campaigns.",
          },
          {
            title: '2.2. COOKIES ',
            sectionContent:
              'Your internet browser has the built-in function of storing small text files – “cookies” – that contain information that allows a website to recognize your account.\n\nThe <strong>BAZI BY MARINA</strong> website may use “cookies” and other similar technologies. These technologies help us better understand User behavior and tell us which parts of our site people have visited, measure and contribute to the effectiveness of marketing activities and web searches, and personalize your experience.\n\nMost browsers allow you to control cookies, including whether or not to accept them and how to remove them. You can set most browsers to notify you if you receive a cookie, or you can choose to block cookies in your browser. If you want to disable cookies, check with your manufacturer/browser to find out how to block them. ',
          },
          {
            title: '3. PURPOSE OF PROCESSING PERSONAL DATA ',
            sectionContent:
              "The Processing of your Personal Data may be carried out by <strong>BAZI BY MARINA</strong> with your consent, when applicable, in different ways, by legal, regulatory, contractual obligation or other forms. <strong>BAZI BY MARINA</strong> may ask you to provide written consent or by any means confirming such consent, whenever necessary.\n\nWe may use your Personal Information for the following purposes:\n\na) Provide and operate the Services of <strong>BAZI BY MARINA</strong>;\n\nb) Develop, customize and improve our Services based on Users' common or personal preferences, experiences and difficulties;\n\nc) Analyze trends and learn about user behavior on the site and collect demographic information about our User base as a whole;\n\nd) Mapping, defining, creating and developing commercial and marketing strategies, as well as operating, providing and improving our Services and advertising;\n\ne) Provide our Users with ongoing and personalized customer service and technical support;\n\nf) Being able to get in touch with our Users through general or personalized promotional messages and notifications regarding the Services;\n\ng) Enhance network security, including to protect our Services for the benefit of all our Users;\n\nh) Internal purposes, such as auditing, data analysis and research to improve <strong>BAZI BY MARINA</strong>'s Services and customer communications;\n\ni) Create aggregated statistical data and other Personal Information aggregated and/or inferred about your profile and that of other Users who access the website, allowing the development of Services;\n\nj) Comply with legal obligations to which <strong>BAZI BY MARINA</strong> is subject, comply with applicable laws and regulations.\n\nk) Identify and/or offer you relevant content about a particular preference and/or interest expressed by you to <strong>BAZI BY MARINA</strong>, including, without limitation, newsletters, events, invitations, reminders, thank you notes, among others;\n\nl) Carry out a satisfaction survey and feedback on our services and initiatives.\n\nm) Compose a database of suppliers and service providers of <strong>BAZI BY MARINA</strong>;\n\nn) Create a database of candidates for jobs, internships and services provided by <strong>BAZI BY MARINA</strong>;\n\no) Protect, defend and manage the interests of <strong>BAZI BY MARINA</strong>;\n\nAny comments made on the <strong>BAZI BY MARINA</strong> website may be used for advertising purposes; this does not constitute an offense or violation of their rights, under the terms of item X, article 5 of the Federal Constitution. However, the <strong>BAZI BY MARINA</strong> website guarantees the use of Personal Information limited to the indication of the first and last name next to the comment made and that the User may request the exclusion of the comment at any time by sending a communication to <strong>BAZI BY MARINA</strong> through the channel <a href='mailto:marina.caramez1@gmail.com' target='_blank'>marina.caramez1@gmail.com</a>.",
          },
          {
            title: '4. SHARING AND PROCESSING OF PERSONAL INFORMATION ',
            sectionContent:
              '<strong>BAZI BY MARINA</strong> will not market your Personal Data. However, your Personal Data may be shared or transferred to third parties, in Brazil and/or abroad, in the following situations and within the limits required and authorized by law:\n\na) With its customers and partners when necessary and/or appropriate for the provision of Services and related to solutions that complement, facilitate and improve the Services of <strong>BAZI BY MARINA</strong>. These services can be server hosting and collocation, communications and content delivery networks (CDNs), cyber and data security services, billing and payment processing services, domain name registration, fraud detection, web analytics, email delivery and monitoring services, session recording and remote access services, performance measurement services, data optimization and marketing, content providers and our legal and financial advisors;\n\nb) With companies and individuals contracted to carry out certain activities and services on behalf of <strong>BAZI BY MARINA</strong>;\n\nc) With its direct and indirect subsidiary companies;\n\nd) With suppliers and partners to carry out the Services contracted with <strong>BAZI BY MARINA</strong>;\n\ne) For administrative purposes such as: research, planning, development of Services, security and risk management;\n\nf) <strong>BAZI BY MARINA</strong> may also share your Personal Information with third parties for other purposes by your further guidance or with your express approval;\n\ng) If <strong>BAZI BY MARINA</strong> undergoes changes of control, including through a merger, acquisition or purchase of a substantially part of its assets, your Personal Information may be shared with the parties involved in such event.\n\n In the event of sharing Personal Data with third parties, all subjects mentioned in items “a” to “g” must use the Personal Data shared consistently and in accordance with the purposes for which they were collected (or with which the User previously consented) and as provided by this Privacy Policy, other website or country privacy statements, and all applicable privacy and data protection laws.\n\nIn all cases, <strong>BAZI BY MARINA</strong> undertakes to strictly share the Personal Data that may be necessary to fulfill the respective purpose. ',
          },
          {
            title: '5. LEGAL REASONS FOR DATA DISCLOSURE ',
            sectionContent:
              'In certain circumstances, <strong>BAZI BY MARINA</strong> may disclose Personal Data, to the extent necessary or appropriate, to government agencies, consultants and other third parties for the purpose of complying with applicable law or with court requests, such as subpoenas, court proceedings, search warrants or court orders, or if <strong>BAZI BY MARINA</strong> believes in good faith that such action is necessary to:\n\na) Comply with legislation requiring such disclosure;\n\nb) Investigate, prevent or take action relating to suspected or actual illegal activities or to cooperate with public entities or to protect national security;\n\nc) Execution of its contracts;\n\nd) Investigate and defend against any third party claims or allegations;\n\ne) Protect the security or integrity of the Services;\n\nf) Exercise or protect the rights, property and security of <strong>BAZI BY MARINA</strong> and its affiliated companies;\n\ng) Protect the rights and personal safety of its employees, Users or the public;\n\nBAZI BY MARINA may contest these demands if it deems that the requests are excessive, vague or made by incompetent authorities. ',
          },
          {
            title:
              '6. PRIVACY, SECURITY AND PROTECTION OF PERSONAL INFORMATION ',
            sectionContent:
              '<strong>BAZI BY MARINA</strong> and the third parties with which your Personal Data may eventually be shared observe the security standards necessary to prevent and remedy unauthorized access to Personal Data, using the applicable means and recommended security standards to protect them, as it is technically and operationally viable.\n\nBAZI BY MARINA and its suppliers use security procedures to protect the confidentiality, security and integrity of your Personal Data, preventing the occurrence of possible damages due to the processing of such data.\n\nAlthough <strong>BAZI BY MARINA</strong> uses security measures and monitors its system to verify vulnerabilities and attacks to protect the Personal Data against unauthorized disclosure, misuse or alteration, the User understands and agrees that there are no guarantees that the information will not be accessible, disclosed, altered or destroyed by breach of any of the physical, technical or administrative safeguards. ',
          },
          {
            title: '7. DATA RETENTION ',
            sectionContent:
              "<strong>BAZI BY MARINA</strong> may store Users' Personal Data for the time necessary to fulfill the purposes mentioned in this policy, as well as to comply with the applicable legislation or regulation, as the case may be. In order to determine the form and duration of the Processing of your Personal Data by <strong>BAZI BY MARINA</strong>, the nature of your Personal Data provided will be considered, as well as the purpose of the Processing. Once the purpose of the Processing of your Personal Data has been exhausted, they will be deleted.\n\nThe end of data processing and deletion of personal data will also occur when the Data Holder is within his right to request the end of treatment and deletion of his personal data and he does so, and / or when there is a legal determination in this regard.\n\nBAZI BY MARINA may keep your Personal Data after receiving your request for deletion or after the end of purpose if necessary to comply with legal obligations, resolve disputes, maintain security, prevent fraud and/or abuse and ensure compliance with contracts.\n\nFor more information about where and how long your Personal Data will be stored, as well as more information regarding your deletion and portability rights, please contact <a href='mailto:marina.caramez1@gmail.com' target='_blank'>marina.caramez1@gmail.com</a>.",
          },
          {
            title: '8. PERSONAL DATA HOLDER RIGHTS ',
            sectionContent:
              '<strong>BAZI BY MARINA</strong> recognizes and agrees that every natural person is assured the ownership of their Personal Data and guaranteed the fundamental rights of freedom, intimacy and privacy, under the terms of the legislation and, therefore, guarantees that the holder of the Personal Data has the right to obtain, at any time, upon request:\n\na) Confirmation of data processing: the User may request confirmation whether <strong>BAZI BY MARINA</strong> and/or authorized third parties are processing his data, even after the end of his relationship with <strong>BAZI BY MARINA</strong>;\n\nb) Obtaining information about which Personal Data is stored and otherwise processed by <strong>BAZI BY MARINA</strong>;\n\nc) Deletion of data: the User may request the deletion of all or some of his Personal Data (for example, if it is no longer necessary to provide the Services);\n\nd) Alteration or correction of data: the User can edit or request the edition of his Personal Data. The User can also request updates, alterations or corrections of his data, especially if it is incorrect, incomplete or out of date;\n\ne) Objections, limits or restrictions to the use of data: the User may request the interruption of the use of all or some of his Personal Data, or limit our use of such data, emphasizing that <strong>BAZI BY MARINA</strong> may process the Data Personal according to the purposes listed in topic 3;\n\nf) Access to data: the User may request a copy of his Personal Data and the data that the User has provided in a readable format in printed form or electronically.\n\nThere are legal circumstances that may restrict the exercise of certain rights provided by law, especially when the provision of information may reveal a business secret of <strong>BAZI BY MARINA</strong>.\n\nThe User may make the requests listed above by contacting us at <a href="mailto:marina.caramez1@gmail.com" target="_blank">marina.caramez1@gmail.com</a> and these requests will be considered in accordance with applicable laws. ',
          },
          {
            title: '9. <strong>BAZI BY MARINA</strong> COMMUNICATIONS ',
            sectionContent: '',
          },
          {
            title: '9.1. PROMOTIONAL MESSAGES ',
            sectionContent:
              'We may use your Personal Information to send you promotional content and messages via email, text messages, notifications on our platform, marketing calls and similar forms of communication from <strong>BAZI BY MARINA</strong> or our partners (acting on behalf of <strong>BAZI BY MARINA</strong> ) by such means.\n\nIf you do not wish to receive these promotional messages or calls, you may notify <strong>BAZI BY MARINA</strong> at any time or follow the “unsubscribe” or STOP instructions contained in any promotional communications you receive. ',
          },
          {
            title: '9.2. SERVICE MESSAGES ',
            sectionContent:
              '<strong>BAZI BY MARINA</strong> may also contact you with important information regarding our Services or your use of them. It is important that you are always able to receive these messages, for that reason, you cannot opt out of receiving such Service Messages unless you cease to be a User of <strong>BAZI BY MARINA</strong>. ',
          },
          {
            title: '10. LINKS TO THIRD PARTY WEBSITES ',
            sectionContent:
              'The <strong>BAZI BY MARINA</strong> website may have links to/with other websites, which, in our opinion, may contain useful information/tools for our Users.\n\nWe expressly emphasize that our privacy policy is not applicable to third-party websites, so if Users visit another website from the <strong>BAZI BY MARINA</strong> website, they must read and agree with the privacy policy of that website.\n\n <strong>BAZI BY MARINA</strong> is not responsible, in any way and under any claim, for the privacy policy and/or content present on these websites. ',
          },
          {
            title: '11. CHANGES AND REVISIONS OF THIS PRIVACY POLICY ',
            sectionContent:
              '<strong>BAZI BY MARINA</strong> reserves the right, at any time, to modify, change, add or remove parts of this policy, by publishing the updated version on this page.\n\nThe use of the Site or the provision of Personal Data by any other means implies your agreement with this Privacy Policy. ',
          },
          {
            title: '12. CONTACT ',
            sectionContent:
              'In case of doubt regarding the provisions contained in this Privacy Policy, or in case of any request that you are interested in making regarding your data, please contact us via e-mail <a href="mailto:marina.caramez1@gmail.com" target="_blank">marina.caramez1@gmail.com</a>. ',
          },
          {
            title: '13. JURISDICTION ',
            sectionContent:
              'This Privacy Policy will be governed and interpreted in accordance with Brazilian law, with the Jurisdiction of the Central District of Rio de Janeiro being elected to resolve any litigation or controversy involving this document.\n\nThis Privacy Policy is effective on [05/29/2023]. ',
          },
        ],
      },
      pagination: {
        next: 'Next',
        previous: 'Previous',
      },
      cookies: {
        title: 'This website uses cookies',
        description:
          'We collect data to improve website performance and security. To find out more, see our',
        accept: 'Accept',
      },
      loading: 'Loading...',
      share: 'Share',
      ecmaNotSupported:
        'This browser does not fully support our website. \n\nIn order to browse without any problems, we recommend that you update your browser or try using another.',
    },
  },
};

export { messages };
